import { useContext } from 'react';
import { DatosNegocioContext } from './DatosNegocioContext';

const useDatosNegocio = () => useContext(DatosNegocioContext);

export default useDatosNegocio;